import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function SwecSIHGrandFinale20251208() {

    const images = [
        "sih1.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        SWEC Team Selected for Smart India Hackathon Grand Finale 2025
                                    </h2>

                                    <p>
                                        CSE Department third-year student team <strong>“Bruteforce”</strong> has been
                                        shortlisted for the <strong>Smart India Hackathon (SIH) Grand Finale – Software Edition</strong>,
                                        scheduled from <strong>8th to 12th December 2025</strong> at
                                        Oriental University, Indore, Madhya Pradesh.
                                    </p>

                                    <p>
                                        This marks the <strong>second consecutive time</strong> our students have earned this
                                        prestigious opportunity, continuing SWEC’s tradition of innovation,
                                        technical excellence, and impactful problem-solving.
                                    </p>

                                    <p>
                                        Congratulations to the team and best wishes for the Grand Finale!
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/swec-sih-grand-finale-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/swec-sih-grand-finale-2025/${img}`}
                                                            alt={`Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default SwecSIHGrandFinale20251208;